var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container",attrs:{"id":_vm.id}},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.checkImg,"alt":_vm.name},on:{"click":function($event){return _vm.toggleCheck()}}}),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }